import { render, staticRenderFns } from "./AppSVGWelcome.vue?vue&type=template&id=c9516358&"
import script from "./AppSVGWelcome.vue?vue&type=script&lang=js&"
export * from "./AppSVGWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports